var Requisition = /** @class */ (function () {
    function Requisition() {
        this.cloudFileLocation = '';
        this.hrxmlCloudFileLocation = '';
        this.length = '';
        this.fileSize = '';
        this.fileName = '';
        this.hrxmlFileName = '';
        this.user = null;
        this.company = null;
        this.clientOrBU = null;
        this.isSharedClientRequisition = false;
        this.sharedClientBuOrCorpId = null;
    }
    return Requisition;
}());
export { Requisition };
//# sourceMappingURL=requisition.js.map